import { connect } from "react-redux";
import { ApplicationState } from "store";
import {
    actionCreators as uiActionCreators,
    getActiveNavigationComponent,
    getRubberbandItem,
    getShowMainMenu,
    getSpiralItem,
    getThumbnailBlob,
} from "ui/store";
import { actionCreators, getCalendar } from "page/calendar/store";
import ControlsNavigation from "./controls-navigation";
import { getResource } from "resource/store";
import {
    getBackCoverImage,
    getCoverImage,
    getCustomBackImage,
    getCustomCoverImage,
} from "burde-api-content/store";

const mapStateToProps = (state: ApplicationState) => ({
    NavControls_Close: getResource(state, { key: "NavControls_Close" }),
    NavControls_Checkout: getResource(state, { key: "NavControls_Checkout" }),
    NavControls_Summary: getResource(state, { key: "NavControls_Summary" }),
    NavControls_ToCheckout: getResource(state, {
        key: "NavControls_ToCheckout",
    }),
    NavControls_Lined: getResource(state, { key: "NavControls_Lined" }),
    calendar: getCalendar(state),
    activeComponent: getActiveNavigationComponent(state),
    showMainMenu: getShowMainMenu(state),
    thumbnailBlob: getThumbnailBlob(state),
    coverImage: getCoverImage(state),
    backCoverImage: getBackCoverImage(state),
    customCoverImage: getCustomCoverImage(state),
    customBackImage: getCustomBackImage(state),
    spiral: getSpiralItem(state),
    rubberband: getRubberbandItem(state),
});

const mapDispatchToProps = {
    ...actionCreators,
    ...uiActionCreators,
};

export default connect(mapStateToProps, mapDispatchToProps)(ControlsNavigation);
